module.exports = __webpack_public_path__ + "static/media/logo_text1.5f90d930.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_text1.svg
// module id = 168
// module chunks = 0